import { useMediaQuery } from 'usehooks-ts'
import { SansTitle } from '../SansTitle/SansTitle'
import { SerifTitle } from '../SerifTitle/SerifTitle'
import { Title } from './TitleComposition.styles'
import type { TitleCompositionProps } from './TitleComposition.types'

export const TitleComposition = ({
  title,
  upperTitle,
  className,
}: TitleCompositionProps): JSX.Element => {
  const isMinWidth768px = useMediaQuery('(min-width: 768px)')

  return (
    <Title className={className}>
      <SerifTitle as="h2" size={isMinWidth768px ? 'xl' : 'md'} color="primary">
        {title}
      </SerifTitle>
      <SansTitle
        tracking="wide"
        as="h3"
        size={isMinWidth768px ? 'base' : 'sm'}
        color="primary"
      >
        {upperTitle}
      </SansTitle>
    </Title>
  )
}
